(function () {
  function initStickyAtc() {
    const formElement = document.querySelector('.product-form__buttons--sticky');
    const addToCartButton = document.querySelector('.atc-sticky-scroll');

    if (!formElement || !addToCartButton || formElement.dataset.bcjStickyAtcReady) return;
    formElement.dataset.bcjStickyAtcReady = 'true';

    const setStickyState = (isSticky) => {
      formElement.classList.toggle('sticky_position', isSticky);
    };

    const bundleSection = formElement.closest('[data-bcj-bundle-product]');
    if (bundleSection) {
      // Bundle pages use one geometry owner: scroll can jump past both IO
      // thresholds, and the sticky buy action must never obscure the footer.
      const footer = document.querySelector('.site-footer, #shopify-section-footer, footer[role="contentinfo"]');
      const primaryButton = bundleSection.querySelector('[data-add-to-cart]') || addToCartButton;
      let frameId = null;
      const updateBundleStickyState = () => {
        frameId = null;
        const hasPassedViewport = primaryButton.getBoundingClientRect().bottom <= 0;
        const footerBelowViewport = !footer || footer.getBoundingClientRect().top > window.innerHeight;
        const isSticky = hasPassedViewport && footerBelowViewport;
        setStickyState(isSticky);
        formElement.inert = !isSticky;
        formElement.setAttribute('aria-hidden', isSticky ? 'false' : 'true');
      };
      const scheduleBundleStickyUpdate = () => {
        if (frameId === null) frameId = window.requestAnimationFrame(updateBundleStickyState);
      };
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(scheduleBundleStickyUpdate) : null;
      if (observer) {
        observer.observe(primaryButton);
        if (footer) observer.observe(footer);
      }
      window.addEventListener('scroll', scheduleBundleStickyUpdate, { passive: true });
      window.addEventListener('resize', scheduleBundleStickyUpdate);
      const unload = (event) => {
        if (!event.target.contains(bundleSection)) return;
        if (observer) observer.disconnect();
        if (frameId !== null) window.cancelAnimationFrame(frameId);
        window.removeEventListener('scroll', scheduleBundleStickyUpdate);
        window.removeEventListener('resize', scheduleBundleStickyUpdate);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      updateBundleStickyState();
      return;
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const hasPassedViewport = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;

        setStickyState(hasPassedViewport);
      });

      observer.observe(addToCartButton);
      return;
    }

    let frameId = null;

    const updateStickyState = () => {
      frameId = null;
      setStickyState(addToCartButton.getBoundingClientRect().bottom <= 0);
    };

    const scheduleStickyUpdate = () => {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(updateStickyState);
    };

    window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyUpdate);
    scheduleStickyUpdate();
  }

  function initQuantitySync() {
    document.querySelectorAll('[data-section-type="product"]').forEach((section) => {
      if (!section.querySelector('.product-form__buttons--sticky') || section.dataset.bcjQuantitySync) return;
      section.dataset.bcjQuantitySync = 'true';

      function syncQuantity(sourceInput) {
        if (!sourceInput || sourceInput.closest('[data-section-type="product"]') !== section) return;
        section.querySelectorAll('.js-qty__num').forEach((input) => {
          if (input !== sourceInput && input.closest('[data-section-type="product"]') === section) {
            input.value = sourceInput.value;
          }
        });
      }

      function syncTypedQuantity(event) {
        const input = event.target.closest && event.target.closest('.js-qty__num');
        syncQuantity(input);
      }

      section.addEventListener('input', syncTypedQuantity);
      section.addEventListener('change', syncTypedQuantity);
      section.addEventListener('click', function (event) {
        const button = event.target.closest && event.target.closest('.js-qty__adjust');
        if (!button) return;
        // The theme QtySelector already changed the value at the button.
        // This bubbling listener only mirrors it into this product's other control.
        syncQuantity(button.closest('.js-qty__wrapper')?.querySelector('.js-qty__num'));
      });
    });
  }

  function init() {
    initStickyAtc();
    initQuantitySync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
